import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// @ts-nocheck
import context from "./plugin/context";
var autoExpo = function autoExpo(tracert, cb) {
  tracert.set(_objectSpread({}, context));
  var firstCalled = true;
  // TODO:有个问题，有可能set在logPv之前导致曝光没有pageId，但是设置after('logPv')会导致之前在logPv之后调用set方法失效
  // 判断是否默认开启曝光埋点
  tracert.before('set', function (options) {
    if (!options.autoExpo) {
      return;
    }
    // TODO:这里的问题是要感知ap中的_calledLogPv，实际plugin之间是独立的
    if (tracert._calledLogPv !== undefined) {
      // logPv已调用，已有pageId，直接调用
      if (tracert._calledLogPv) {
        tracert.call('startAutoExpo');
        return;
      }
      // logPv之前设置，需要等logPv调用结束, 仅首次调用后执行
      tracert.after('logPv', function () {
        if (firstCalled) {
          tracert.call('startAutoExpo');
          firstCalled = false;
        }
      });
      return;
    }
    tracert.call('startAutoExpo');
  });
  if (cb) {
    cb === null || cb === void 0 ? void 0 : cb();
  }
  return tracert;
};
export default autoExpo;